<template>
  <q-page padding>
    <PageHeader :backRoute="{ name: 'home' }" backBehavior="route">
      <template #title>
        {{
          tab === "renovacao"
            ? "Renovação de Emprestimos"
            : "Devolução de Ferramenta"
        }}
      </template>
    </PageHeader>
    <div class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold">
      <div class="col-md-2 col-xs-5">
        <div class="titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>

      <div v-if="temPermissaoCracha()" class="col-md-2 col-xs-5">
        <div class="texto-titulo-select">Crachá Solicitante</div>
        <SelecaoFuncionario
          dense
          outlined
          v-model="crachaSolicitante"
          @emitirFuncionario="receberFuncionarioPorCracha"
          :resetar="resetarFuncionario"
          :atualizarDados="atualizarDadosUsuario"
          debounce="500"
          :buscarPorCracha="true"
        />
      </div>

      <div class="col-md-2 col-xs-5">
        <div class="titulo-input">Nome do Requisitante</div>
        <SelecaoFuncionario
          @emitirFuncionario="receberFuncionario"
          :resetar="resetarFuncionario"
          :atualizarDados="atualizarDadosUsuario"
          :deletado="tab === 'devolucao' ? usuarioDeslisgado : false"
          :isSingle="true"
        />
      </div>
      <SelecaoLocalDeposito
        class="col-md-2 col-xs-5"
        @enviarDeposito="receberDeposito"
      />
    </div>
    <div
      class="row col-12 q-mt-sm text-brand-5 text-weight-bold"
      v-if="tab === 'devolucao'"
    >
      <div>
        <q-toggle label="Usuários Desligados" v-model="usuarioDeslisgado" />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div
          class="col-12 q-ml-md text-brand-5 text-weight-bold q-mb-md titulo-tabela"
        >
          {{
            tab === "renovacao"
              ? "Ferramentas para Renovação"
              : "Ferramentas a Serem Devolvidas"
          }}
        </div>
        <div class="row col-12">
          <ComponenteFiltros
            :codigo="true"
            :classCodigo="'col-md col-xs-6'"
            :descricao="true"
            :classDescricao="'col-md col-xs-5'"
            :patrimonio="true"
            :classPatrimonio="'col-md col-xs-6'"
            :classGrupo="'col-md col-xs-5'"
            :subgrupo="true"
            :classSubgrupo="'col-md col-xs-6'"
            @enviarFiltro="receberFiltro"
          />
        </div>
      </div>
      <q-tabs
        dense
        class="text-grey bg-grey-3 q-mb-sm"
        active-color="black"
        indicator-color="primary"
        active-bg-color="brand-11"
        no-caps
        align="justify"
        narrow-indicator
        inline-label
        v-model="tab"
      >
        <q-tab
          style="background-color: #d9d9d9; border-radius: 4px"
          name="devolucao"
          label="Ferramentas a Serem Devolvidas"
          no-caps
        />
        <q-tab
          v-if="podeRenovarEmprestimo"
          class="q-ml-sm q-mr-sm"
          style="background-color: #d9d9d9; border-radius: 4px"
          name="renovacao"
          label="Renovação de Emprestimos"
          no-caps
        />
      </q-tabs>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="listaFerramenta"
        selection="multiple"
        dense
        row-key="ativoUuid"
        :hideBottom="!listaFerramenta.length == 0"
        no-data-label="Nenhuma ferramenta encontrada."
        v-model:selected="selected"
        :rows-per-page-options="[0]"
        :filter="filtros.filtroAtivos"
        :class="{ 'my-sticky-dynamic': !mobile }"
        flat
        :grid="mobile"
      >
        <template v-slot:item="props">
          <div class="row col-12"></div>
          <q-card
            @click="
              autenticacao || (tab === 'renovacao' && autenticacaoRenovacao)
                ? quasar.notify({
                    message:
                      'Não é possivel remover ou selecionar novos ativos depois de criar a devolução.',
                    color: 'negative',
                    actions: [
                      {
                        label: 'Fechar',
                        color: 'white',
                        handler: () => {
                          /* ... */
                        },
                      },
                    ],
                  })
                : (props.selected = !props.selected)
            "
            class="container-grid-table row col-12 q-mt-sm"
            :style="
              props.selected
                ? 'transform: scale(0.98); background: #b7cdf6'
                : ''
            "
          >
            <div class="row col-12 items-center q-pa-sm">
              <div class="col-7">
                <div class="row col-12">
                  <span style="word-break: break-all"
                    ><strong>Código: </strong
                    >{{ props.row?.catalogoItem?.codigo }}</span
                  >
                </div>
                <div class="row col-12">
                  <span style="word-break: break-all"
                    ><strong>Descrição: </strong
                    >{{ props.row?.catalogoItem?.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <span><strong>Preço: </strong>{{ props.row?.preco }}</span>
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Patrimônio: </strong
                    >{{ props.row?.patrimonio }}</span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Grupo: </strong
                    >{{ props.row?.catalogoItem?.catalogoGrupo.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Subgrupo: </strong
                    >{{ props.row?.catalogoItem?.catalogoSubGrupo.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <div
                    v-if="props.row?.atributos?.length > 0"
                    class="row col-12"
                  >
                    <span class="q-mr-sm"
                      ><strong>Chave: </strong
                      >{{ props.row?.atributos[0].chave }}</span
                    >
                    <span
                      ><strong>Valor: </strong>{{ props.row?.atributos[0].valor
                      }}<span v-if="props.row?.atributos?.length > 1"
                        >....</span
                      ></span
                    >
                    <q-tooltip v-if="props.row?.atributos?.length > 1">
                      <div
                        v-for="(atributo, index) in props.row?.atributos"
                        :key="index"
                      >
                        <div class="row col-12" v-if="atributo.valor">
                          <div class="row col-12 justify-between">
                            <span class="q-mr-sm"
                              >Chave: {{ atributo.chave }}
                            </span>
                            <span>Valor: {{ atributo.valor }}</span>
                          </div>
                        </div>
                      </div>
                    </q-tooltip>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row col-12 justify-end items-center">
                  <div class="q-mr-sm">
                    <div
                      style="
                        border: 1px solid #707070;
                        height: 60px;
                        width: 60px;
                        border-radius: 5px;
                        background-color: white;
                      "
                      class="items-center row col justify-center"
                    >
                      <q-img
                        v-if="props.row.urlImagem"
                        fit="contain"
                        height="100%"
                        width="95%"
                        :src="props.row.urlImagem"
                      />
                      <q-img
                        v-else
                        fit="contain"
                        height="100%"
                        width="95%"
                        src="../../../assets/semImagem.jpg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </q-card>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td class="coluna-selecionar">
              <q-btn
                round
                size="10px"
                :icon="props.selected ? 'close' : 'add'"
                :color="props.selected ? 'red' : 'secondary'"
                :disable="
                  autenticacao || (tab === 'renovacao' && autenticacaoRenovacao)
                "
                @click="props.selected = !props.selected"
              />
            </q-td>
            <q-td>
              {{ props.row?.catalogoItem?.codigo }}
            </q-td>
            <q-td>
              {{ props.row?.catalogoItem?.nome }}
            </q-td>
            <q-td>
              {{ props.row?.preco }}
            </q-td>
            <q-td>
              {{ props.row?.patrimonio }}
            </q-td>
            <q-td>
              {{ props.row?.catalogoItem?.catalogoGrupo.nome }}
            </q-td>
            <q-td>
              {{ props.row?.catalogoItem?.catalogoSubGrupo.nome }}
            </q-td>
            <q-td>
              <div v-if="props.row?.atributos?.length > 0">
                <div>
                  <span class="q-mr-xs"
                    >Chave: {{ props.row?.atributos[0].chave }}
                  </span>
                  <span> Valor: {{ props.row?.atributos[0].valor }}</span>
                  <span v-if="props.row?.atributos?.length > 1">....</span>
                </div>
                <q-tooltip v-if="props.row?.atributos?.length > 1">
                  <div
                    v-for="(atributo, index) in props.row?.atributos"
                    :key="index"
                  >
                    <div class="row col-12" v-if="atributo.valor">
                      <div class="row col-12 justify-between">
                        <span class="q-mr-sm"
                          >Chave: {{ atributo.chave }}
                        </span>
                        <span> Valor: {{ atributo.valor }}</span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </div>
              <div v-else>Sem Atributos</div>
            </q-td>
            <q-td>
              <q-btn
                icon="chat"
                outline
                color="brand-1"
                round
                flat
                @click="setComentario(props.row)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <q-dialog v-model="showComentarioRetirada">
        <q-card style="width: 500px">
          <q-card-section>
            <div class="text-h6">Comentario Retirada</div>
          </q-card-section>
          <q-separator />
          <q-card-section style="height: 200px" class="q-pt-none">
            {{ comentarioRetirada }}
          </q-card-section>

          <q-card-actions align="right">
            <q-btn flat label="OK" color="primary" v-close-popup />
          </q-card-actions>
        </q-card>
      </q-dialog>
      <div v-if="listaFerramenta.length > 0" class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <div class="q-mt-xl" v-if="selected.length > 0">
      <div class="row col-12 justify-between items-center">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          {{
            tab === "renovacao" ? "Resumo da Renovação" : "Resumo da Devolução"
          }}
        </div>
      </div>
    </div>
    <ComponenteChecklistAcessorio
      :etapa="'devolucao'"
      :verificar="validarRespostas"
      :arrayRespostas="selected"
      :respostas="respostas"
      :tela="'devolucao'"
      :botaoRemover="true"
      :perguntas="true"
      @removerAtivo="removerFerramenta"
      @enviarValidacaoRespostas="verificarRespostas"
    />

    <ComponenteAutenticacao
      :autenticacao="tab === 'renovacao' ? autenticacaoRenovacao : autenticacao"
      :usuario="dados.dadosRequisitante"
      :etapa="'devolucao'"
      :resetar="resetarAutenticacao"
      :atualizarUserLogado="atualizarUserLogado"
      :desabilitarBotaoCriar="desabilitarBotaoCriar"
      :campoObservacao="true"
      :isRenovacao="tab === 'renovacao'"
      @enviarAutenticacaoSolicitante="receberAutenticacaoSolicitante"
      @enviarAutenticacaoAlmoxarife="receberAutenticacaoAlmoxarife"
      @iniciarAutenticacao="iniciarProcesso"
      @atualizarTemplates="atualizarTemplatesBiometria"
      @finalizarProcesso="processarFinalizacao"
      @enviarSetupConfiguracao="receberSetupConfiguracao"
      @resetarAutenticacao="resetVariaveis"
    />
  </q-page>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoFuncionario from "../components/SelecaoFuncionario.vue";
import ComponenteAutenticacao from "../components/ComponenteAutenticacao.vue";
import SelecaoLocalDeposito from "../components/SelecaoLocalDeposito.vue";
import ComponenteChecklistAcessorio from "../components/ComponenteChecklistAcessorio.vue";
import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "valor",
    label: "Preço",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "atributo",
    label: "Atributos",
    align: "left",
  },
  {
    name: "obervacao",
    label: "Observações",
    align: "left",
  },
];
const columns2 = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "valor",
    label: "Preço",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "atributo",
    label: "Atributos",
    align: "left",
  },
];
export default {
  components: {
    ListaUnidadesSelect,
    SelecaoFuncionario,
    ComponenteAutenticacao,
    SelecaoLocalDeposito,
    ComponenteChecklistAcessorio,
    ComponenteFiltros,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const podeRenovarEmprestimo = computed(() => {
      const permissoes =
        store.state.autenticacao.usuarioLogado?.permissoes?.gmapi?.roles || [];
      return permissoes.includes("atv-ativo-emprestimo-renovar");
    });

    const dados = ref({
      metodoAutenticacao: "",
      dadosRequisitante: {
        id: "",
        nome: "",
        matricula: "",
        biometria: "",
      },
    });
    const listaFerramenta = ref([]);
    const resetarFuncionario = ref(0);
    const selected = ref([]);
    let showComentarioRetirada = ref(false);
    const comentarioRetirada = ref(null);
    const base64 = ref(null);
    let usuarioVerificado = ref(false);
    const salvarAssinatura = ref(0);
    const pin = ref("");
    let disable = ref(false);
    let autenticacaoFeita = ref(false);
    let biometriaModal = ref(false);
    let mobile = ref(false);
    let rightDrawerOpen = ref(false);
    const deposito = ref({});
    const desabilitarBotaoCriar = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let loading = ref(false);
    const usuarioDeslisgado = ref(false);
    const listaSelecionados = ref([]);
    let autenticacao = ref(false);
    const atualizarUserLogado = ref(0);
    const filtroSelecionado = ref("");
    const autenticacaoSolicitante = ref({
      authType: "",
      authContent: "",
    });
    const autenticacaoAlmoxarife = ref({
      authType: "",
      authContent: "",
    });
    const crachaSolicitante = ref(null);
    const usuarioEncontradoPorCracha = ref(null);
    const resetarAutenticacao = ref(0);
    const respostas = ref({ responderCheckLists: "", responderAcessorios: "" });
    const atualizarDadosUsuario = ref(0);
    const filtros = ref({});
    const validarRespostas = ref(0);

    const tab = ref("devolucao");
    const saveRow = ref([]);
    const autenticacaoRenovacao = ref(false);

    const cacheAutenticacao = ref({
      solicitante: {
        authType: "",
        authContent: "",
      },
      almoxarife: {
        authType: "",
        authContent: "",
      },
    });

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarFerramentaDevolver = async (page = 1, perPage = 15) => {
      if (
        dados.value.dadosRequisitante.id === "" ||
        dados.value.dadosRequisitante.id === undefined
      ) {
        listaFerramenta.value = [];
        return;
      }
      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarEmprestimo",
          {
            solicitanteId: dados.value.dadosRequisitante.id,
            ativoDevolvido: "nao",
            comCheckLists: "sim",
            comAtributos: "sim",
            comAcessorios: "sim",
            codigo: filtros.value?.codigo,
            nome: filtros.value?.descricao,
            patrimonio: filtros.value.patrimonio,
            nomeGrupo: filtros.value?.grupo?.nome,
            nomeSubgrupo: filtros.value?.subgrupo?.nome,
            page,
            perPage,
          }
        );
        listaFerramenta.value = [];
        if (response.data.resultado.dados.length == 0) {
          loading.value = false;
          disable.value = false;
          return;
        }

        saveRow.value = response.data.resultado.dados;

        response.data.resultado.dados.forEach((emprestimo) => {
          // Verifica se emprestimo.ativo é uma string, se for, transforma em um objeto
          if (typeof emprestimo.ativo === "string") {
            emprestimo.ativo = { valor: emprestimo.ativo };
          }

          // Adiciona comentarioRetirada como uma propriedade no objeto ativo
          emprestimo.ativo.comentarioRetirada = emprestimo.comentarioRetirada;

          // Adiciona o objeto ativo na lista
          listaFerramenta.value.push(emprestimo.ativo);
        });
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
        disable.value = false;
      }
    };

    const receberFuncionario = async (value) => {
      if (value === null) {
        dados.value.dadosRequisitante = {
          id: "",
          nome: "",
          matricula: "",
          biometria: "",
          idTabela: "",
        };
        return;
      }
      dados.value.dadosRequisitante = {
        id: value.id,
        nome: value.nome,
        matricula: value.matricula,
        biometria: value.biometria,
        idTabela: value.idTabela,
      };
      resetVariaveis();
      await listarFerramentaDevolver();
    };

    const devolverFerramenta = async (observacao) => {
      console.log("devolverFerramenta");
      desabilitarBotaoCriar.value = true;

      const ativos = selected.value.map((ativo) => {
        return {
          ativoUuid: ativo.ativoUuid,
          depositoLocalUuid: deposito.value.depositoLocalUuid,
          checkLists:
            ativo?.checkLists?.length > 0
              ? verificarChecklist(ativo?.checkLists)
              : undefined,
          acessorios:
            ativo?.acessorios?.length > 0
              ? verificarAcessorio(ativo?.acessorios)
              : undefined,
        };
      });

      try {
        await store.dispatch("ferramentaria/devolverEmprestimo", {
          unidadeIdDevolucao: store.state.org.unidadeData.id,
          solicitanteId: dados.value.dadosRequisitante.id,
          solicitanteAuthType: autenticacaoSolicitante.value.authType,
          solicitanteAuthContent: autenticacaoSolicitante.value.authContent,
          almoxId: store.state.autenticacao.usuarioLogado.id,
          almoxAuthType: autenticacaoAlmoxarife.value.authType,
          almoxAuthContent: autenticacaoAlmoxarife.value.authContent,
          solicitanteNome: dados.value.dadosRequisitante.nome,
          almoxNome: store.state.autenticacao.usuarioLogado.nome,
          comentarioDevolucao: usuarioDeslisgado.value
            ? `${observacao} - Ativo devolvido após o desligamento do colaborador.`
            : observacao.replace(new RegExp("\\n", "gi"), " "),
          ativos,
        });
        resetVariaveis();
        resetarFuncionario.value++;
        resetarAutenticacao.value++;
        listaFerramenta.value = [];
        desabilitarBotaoCriar.value = false;
        quasar.notify({
          message: "Devolução feita com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        desabilitarBotaoCriar.value = false;

        if (error.response?.data.erros?.mensagem) {
          quasar.notify({
            message: error.response?.data.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data.erro?.mensagem) {
          quasar.notify({
            message: error.response?.data.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data.erro?.detalhes?.ativos?.checkLists) {
          quasar.notify({
            message: "Responda todos os checklists.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const renovarEmprestimo = async (observacao) => {
      console.log("renovarEmprestimo");
      desabilitarBotaoCriar.value = true;

      const comentarioFixo =
        "Devolução realizada a partir de uma renovação de emprestimo";
      const comentarioCompleto =
        observacao && observacao.trim()
          ? `${comentarioFixo} - ${observacao.replace(
              new RegExp("\\n", "gi"),
              " "
            )}`
          : comentarioFixo;

      const ativos = selected.value.map((ativo) => {
        return {
          ativoUuid: ativo.ativoUuid,
          depositoLocalUuid: deposito.value.depositoLocalUuid,
          checkLists:
            ativo?.checkLists?.length > 0
              ? verificarChecklist(ativo?.checkLists)
              : undefined,
          acessorios:
            ativo?.acessorios?.length > 0
              ? verificarAcessorio(ativo?.acessorios)
              : undefined,
        };
      });

      try {
        await store.dispatch("ferramentaria/devolverEmprestimo", {
          unidadeIdDevolucao: store.state.org.unidadeData.id,
          solicitanteId: dados.value.dadosRequisitante.id,
          solicitanteAuthType: cacheAutenticacao.value.solicitante.authType,
          solicitanteAuthContent:
            cacheAutenticacao.value.solicitante.authContent,
          almoxId: store.state.autenticacao.usuarioLogado.id,
          almoxAuthType: cacheAutenticacao.value.almoxarife.authType,
          almoxAuthContent: cacheAutenticacao.value.almoxarife.authContent,
          solicitanteNome: dados.value.dadosRequisitante.nome,
          almoxNome: store.state.autenticacao.usuarioLogado.nome,
          comentarioDevolucao: comentarioCompleto,
          ativos,
        });

        await store.dispatch("ferramentaria/criarEmprestimo", {
          unidadeId: store.state.org.unidadeData.id,
          reservaUuid: "",
          almoxId: store.state.autenticacao.usuarioLogado.id,
          solicitanteId: dados.value.dadosRequisitante.id,
          solicitanteAuthType: cacheAutenticacao.value.solicitante.authType,
          solicitanteAuthContent:
            cacheAutenticacao.value.solicitante.authContent,
          almoxAuthType: cacheAutenticacao.value.almoxarife.authType,
          almoxAuthContent: cacheAutenticacao.value.almoxarife.authContent,
          solicitanteNome: dados.value.dadosRequisitante.nome,
          almoxNome: store.state.autenticacao.usuarioLogado.nome,
          comentarioRetirada: "Empréstimo renovado automaticamente",
          ativos: ativos,
        });

        resetVariaveis();
        resetarFuncionario.value++;
        resetarAutenticacao.value++;
        listaFerramenta.value = [];
        desabilitarBotaoCriar.value = false;
        autenticacaoRenovacao.value = false;

        cacheAutenticacao.value = {
          solicitante: { authType: "", authContent: "" },
          almoxarife: { authType: "", authContent: "" },
        };

        quasar.notify({
          message: "Empréstimo renovado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        desabilitarBotaoCriar.value = false;

        console.error("Erro na renovação:", error);

        if (error.response?.data.erros?.mensagem) {
          quasar.notify({
            message: error.response?.data.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data.erro?.mensagem) {
          quasar.notify({
            message: error.response?.data.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data.erro?.detalhes?.ativos?.checkLists) {
          quasar.notify({
            message: "Responda todos os checklists.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const resetVariaveis = () => {
      autenticacaoFeita.value = false;
      selected.value = [];
      autenticacao.value = false;
      desabilitarBotaoCriar.value = false;
      autenticacaoRenovacao.value = false;
    };

    const receberFuncionarioPorCracha = (value) => {
      if (value === "" || value === null || value === undefined) {
        return;
      }

      const funcionarioFormatado = {
        id: value.id,
        nome: value.nome,
        matricula: value.matricula,
        biometria: value.biometria,
        idTabela: value.idTabela,
      };

      receberFuncionario(funcionarioFormatado);
    };

    const buscarPorCracha = async (card_id) => {
      if (!card_id || card_id.trim() === "") {
        usuarioEncontradoPorCracha.value = null;
        return;
      }

      try {
        const response = await store.dispatch(
          "ferramentaria/listarFuncionarios",
          {
            card_id: card_id,
            vendor_id: store.state.org.unidadeData.id,
          }
        );

        if (response.data?.results?.data?.length > 0) {
          const usuario = response.data.results.data[0];
          usuarioEncontradoPorCracha.value = usuario;

          const funcionarioFormatado = {
            id: usuario.sap,
            idTabela: usuario.id,
            nome: usuario.name,
            matricula: usuario.sap,
            centroCustoCode: usuario.cost_center?.code,
            centroCustoName: usuario.cost_center?.name,
            biometria: usuario.biometry,
          };

          receberFuncionarioPorCracha(funcionarioFormatado);
        } else {
          usuarioEncontradoPorCracha.value = null;
        }
      } catch (error) {
        console.error("Erro ao buscar usuário por crachá:", error);
        usuarioEncontradoPorCracha.value = null;
      }
    };

    const temPermissaoCracha = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-auth-cracha"
        ) || false
      );
    };

    const removerFerramenta = (ativoUuid) => {
      selected.value = selected.value.filter(
        (ferramenta) => ferramenta.ativoUuid != ativoUuid
      );
    };

    const criarDevolucao = () => {
      if (dados.value.dadosRequisitante?.id === "") {
        quasar.notify({
          message: "Selecione um requisitante.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (selected.value.length === 0) {
        quasar.notify({
          message: "Selecione ao menos uma ferramenta.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      quasar.notify({
        message: "Devolução criada.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      autenticacao.value = true;
    };

    const criarRenovacao = () => {
      if (dados.value.dadosRequisitante?.id === "") {
        quasar.notify({
          message: "Selecione um requisitante.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (selected.value.length === 0) {
        quasar.notify({
          message: "Selecione ao menos uma ferramenta.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      quasar.notify({
        message: "Renovação criada.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      autenticacaoRenovacao.value = true;
    };

    const processarFinalizacao = (observacao) => {
      if (tab.value === "renovacao") {
        renovarEmprestimo(observacao);
      } else {
        devolverFerramenta(observacao);
      }
    };

    const receberAutenticacaoSolicitante = (value) => {
      autenticacaoSolicitante.value = value;

      if (tab.value === "renovacao") {
        cacheAutenticacao.value.solicitante = { ...value };
      }
    };

    const receberAutenticacaoAlmoxarife = (value) => {
      autenticacaoAlmoxarife.value = value;

      if (tab.value === "renovacao") {
        cacheAutenticacao.value.almoxarife = { ...value };
      }
    };

    const verificarChecklist = (checklist) => {
      let valido = checklist.every(
        (value) => value.resposta === "sim" || value.resposta === "nao"
      );
      if (!valido) {
        return undefined;
      }
      let array = [];
      checklist.forEach((value) => {
        array.push({
          checkListUuid: value.checkListUuid,
          resposta: value.resposta,
        });
      });
      return array;
    };

    const verificarAcessorio = (acessorios) => {
      let valido = acessorios.every(
        (value) => value.resposta === "sim" || value.resposta === "nao"
      );
      if (!valido) {
        return undefined;
      }
      let array = [];
      acessorios.forEach((value) => {
        array.push({
          acessorioUuid: value.uuid,
          resposta: value.resposta,
        });
      });
      return array;
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        atualizarDadosUsuario.value++;
        atualizarUserLogado.value++;
      } catch (error) {
        console.log(error);
      }
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarFerramentaDevolver();
    };

    const receberSetupConfiguracao = (value) => {
      respostas.value = value;
    };

    const verificarRespostas = () => {
      validarRespostas.value++;
    };

    const iniciarProcesso = () => {
      if (tab.value === "renovacao") {
        criarRenovacao();
      } else {
        criarDevolucao();
      }
    };

    const filtrarSelecionados = () => {
      listaSelecionados.value = selected.value.filter(
        (ativo) =>
          ativo?.codigo
            .toLowerCase()
            .includes(filtroSelecionado.value.toLowerCase()) ||
          ativo?.nome
            .toLowerCase()
            .includes(filtroSelecionado.value.toLowerCase())
      );
    };

    const setComentario = async (comentario) => {
      (showComentarioRetirada.value = !showComentarioRetirada.value),
        (comentarioRetirada.value = comentario.comentarioRetirada);
    };

    const receberDeposito = (value) => {
      deposito.value = value;
    };

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        dados.value.dadosRequisitante = {
          id: "",
          nome: "",
          matricula: "",
          biometria: "",
        };
        resetarFuncionario.value++;
        resetarAutenticacao.value++;
        resetVariaveis();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFerramentaDevolver(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => dados.value.metodoAutenticacao,
      () => {
        autenticacaoFeita.value = false;
        pin.value = "";
        usuarioVerificado.value = false;
        base64.value = null;
      }
    );

    watch(
      () => filtroSelecionado.value,
      () => {
        filtrarSelecionados();
      }
    );

    watch(
      () => selected.value,
      () => {
        filtroSelecionado.value = "";
        listaSelecionados.value = [...selected.value];
      }
    );

    watch(
      () => usuarioDeslisgado.value,
      () => {
        resetarFuncionario.value++;
      }
    );

    watch(
      () => tab.value,
      () => {
        resetVariaveis();
        autenticacaoRenovacao.value = false;
        selected.value = [];

        if (tab.value === "renovacao") {
          usuarioDeslisgado.value = false;
        }
      }
    );

    return {
      columns,
      columns2,
      dados,
      listarFerramentaDevolver,
      receberFuncionario,
      receberFuncionarioPorCracha,
      buscarPorCracha,
      temPermissaoCracha,
      crachaSolicitante,
      usuarioEncontradoPorCracha,
      listaFerramenta,
      selected,
      resetarFuncionario,
      devolverFerramenta,
      renovarEmprestimo,
      processarFinalizacao,
      usuarioVerificado,
      salvarAssinatura,
      disable,
      autenticacaoFeita,
      filtroSelecionado,
      filtrarSelecionados,
      listaSelecionados,
      pin,
      loading,
      biometriaModal,
      mobile,
      quasar,
      rightDrawerOpen,
      criarDevolucao,
      criarRenovacao,
      desabilitarBotaoCriar,
      autenticacao,
      autenticacaoRenovacao,
      atualizarDadosUsuario,
      atualizarTemplatesBiometria,
      removerFerramenta,
      receberAutenticacaoSolicitante,
      receberAutenticacaoAlmoxarife,
      autenticacaoAlmoxarife,
      usuarioDeslisgado,
      autenticacaoSolicitante,
      verificarChecklist,
      resetarAutenticacao,
      respostas,
      pagination,
      resetVariaveis,
      receberDeposito,
      receberSetupConfiguracao,
      verificarAcessorio,
      filtros,
      verificarRespostas,
      iniciarProcesso,
      receberFiltro,
      atualizarUserLogado,
      validarRespostas,
      showComentarioRetirada,
      comentarioRetirada,
      setComentario,
      tab,
      cacheAutenticacao,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      podeRenovarEmprestimo,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}
tbody tr .coluna-selecionar {
  width: 40px !important;
  margin: 0px;
  padding: 3px 2px;
}
tbody tr .coluna-atributo {
  width: 250px !important;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
.titulo-tabela {
  font-size: 18px;
}
.texto-autenticacao-feita {
  font-size: 19px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .titulo-input {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .input {
    font-size: 12px;
  }
  .container-selecao-autenticacao {
    margin: 10px 0px 0px 0px;
  }
  .texto-titulo-modal {
    font-size: 16px;
  }
  .img {
    width: 50px;
    height: 50px;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .titulo-item-texto {
    font-size: 14px;
  }
  .subtitulo-item-texto {
    font-size: 13px;
  }
  .titulo-pergunta-item-texto {
    font-size: 12px;
  }
  .radio {
    font-size: 12px;
  }
  .img {
    width: 50px;
    height: 50px;
  }
}
</style>
